<template>
  <form v-on:submit.prevent="submit($event)" id="contact_form" ref="contactForm">
    <input type="hidden" name="_token" :value="csrf">
    <div class="form-group">
      <label for="name">{{ trans('frontend.name') }}</label>
      <input type="text"
             id="name"
             class="form-control"
             name="name" v-model="v$.formContact.name.$model" :aria-labelledby="trans('frontend.name')">
      <label class="error" v-if="v$.formContact.name.$error">{{ trans("frontend.validate-name") }}</label>
    </div>

    <div class="form-group">
      <label for="email">{{ trans('frontend.email') }}</label>
      <input type="email"
             id="email"
             class="form-control"
             name="email" v-model="v$.formContact.email.$model"
             @change="v$.formContact.email.$touch" :aria-labelledby="trans('frontend.email')">
      <label class="error" v-if="v$.formContact.email.$error">{{ trans("frontend.validate-email") }}</label>
    </div>
    <slot name="recaptcha"></slot>

    <button type="submit" ref="submitBtn" class="btn-submit-form" :disabled="v$.formContact.$invalid" v-if="!showAfterSubmit">
      <span class="txt">{{ trans('frontend.i-want-to-be-contacted') }}</span>
      <span class="the-arrow-right">
        <span class="shaft"></span>
      </span>
    </button>

    <p class="terms-and-conditions" v-if="!showAfterSubmit">
      {{ trans('frontend.terms-and-conditions') }}
      <a :href="privacyPolicySlug" class="policy-anchor" target="_blank">
        {{ privacyPolicyTitle }}
      </a>
      {{ trans('frontend.terms-and-conditions-2') }}
    </p>
  </form>

  <div class="before-form" v-if="showAfterSubmit">
    <p class="thanks">{{ trans('frontend.thank-you') }}</p>
    <p class="message-thanks" v-html="msgAfterSubmit"></p>
    <span class="reset-form" v-on:click="resetForm">
      <span class="close-icon">
        <span class="line"></span>
        <span class="line"></span>
      </span>
      <span class="text">
        {{ trans('frontend.close') }}
      </span>
    </span>
  </div>
</template>

<script>
import {useVuelidate} from '@vuelidate/core'
import {required, email} from '@vuelidate/validators'

export default {
  setup() {
    return {v$: useVuelidate()}
  },
  created() {
    if (!this.csrf) {
      console.warn('The CSRF token is missing. Ensure that the HTML header includes the following: <meta name="csrf-token" content="{{ csrf_token() }}">');
    }
  },
  validations() {
    return {
      formContact: {
        name: {
          required,
        },
        email: {
          required,
          email,
          $lazy: true
        }
      }
    }
  },
  props:{
    captchaKeyTemp: String,
    inputCaptchaTemp: String,
    privacyPolicyTitle: String,
    privacyPolicySlug: String,
  },
  data() {
    return {
      baseUrl: baseUrl,
      csrf: document.head.querySelector('meta[name="csrf-token"]') ? document.head.querySelector('meta[name="csrf-token"]').content : '',
      formContact: {
        name: '',
        email: ''
      },
      showAfterSubmit: false,
      msgAfterSubmit: '',
      recaptchaKey: this.captchaKeyTemp,
      inputRecaptcha: this.inputCaptchaTemp,
    }
  },
  methods: {
    trans(key) {
      return _.get(window.translations, key, key);
    },
    async submit(event) {
      const _self = this;
      const result = await _self.v$.formContact.$validate();
      let xhr = new window.fetchdata();
      let submitUrl = `${window.location.origin}/submitDynamicForm`;

      if (!result) {
        console.log(!result);
        // notify user form is invalid
        event.target.reset();
        alert('notify user form is invalid');
        return
      }

      const recaptchaRegister = document.querySelectorAll(`.${_self.inputRecaptcha}`)[0];//form.find('.g-recaptcha-response-submission-contact');
      this.showLoading = true;

      grecaptcha.execute(this.recaptchaKey)
        .then(function (token) {
          recaptchaRegister.value = token;

          // perform async actions
          let data = {
            type:'submissionContact',
            _token: _self.csrf,
            name: _self.formContact.name,
            email: _self.formContact.email,
            inputCaptchaTemp : token
          }

          xhr.fetchData(submitUrl, "POST", JSON.stringify(data),
            (response) => {
              _self.showAfterSubmit = true;
              _self.msgAfterSubmit = trans('frontend.thank-you-message');

              /*event.target.reset();
              document.getElementById("contact_form").reset();*/

            },
            (response) => {
              console.error(response);
              _self.showAfterSubmit = true;
              _self.msgAfterSubmit = trans('frontend.An error occurred, try later');

              event.target.reset();
            })

        });
     },
    resetForm(){
      const _self= this;
      _self.showAfterSubmit = false;
      _self.formContact.name="";
      _self.formContact.email="";
      _self.v$.$reset()
    }
  }
};
</script>
